/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import $ from 'jquery';
import can from 'can/util/util';
import Component from 'can/component/component';
import FeedService from 'scripts/services/base-feed-service';
import dtm from 'scripts/services/dtm';
import template from './broadcaster-search.stache';

const broadcasterSearchUrl = window.globalSettings.feeds.schedule.broadcasterSearchUrl;

Component.extend({
    tag: "broadcaster-search",
    template: template,
    viewModel: {
        emptyResult: false,
        define: {
            results: {
                type: 'array',
                value: []
            }
        },
        setSearchValue: function (event) {
            let searchValue = can.trim($(event.target).val());
            this.attr('query', searchValue);

            if (searchValue) {
                let results = [];
                searchValue = searchValue.toLowerCase();

                this.attr('countries').map((country, index) => {
                    if (country.country.toLowerCase().indexOf(searchValue) > -1) {
                        results.push(country);
                    }
                });
                this.attr('results', results);
            } else {
                this.attr('results', []);
            }
        },
        trackAnalytics: function () {
            dtm.trackInternationalBroadcast();
        }
    },
    events: {
        inserted(element) {

            this.viewModel.bind('scheduleDate', () => {
                this.viewModel.attr('query', '');
            });

            new FeedService({feedUrl: broadcasterSearchUrl, fromCache: false, autoUpdate: false})
                .on('data', (type, data) => {
                    this.viewModel.attr('countries', data.countries);
                })
                .on('error', (error) => {
                    console.error('Error fetching live tv schedule data', error);
                })
                .fetch();
        },
        '.s-input blur'() {
            this.viewModel.attr('results', []);
        }
    }
});
